import React from 'react';
import cx from 'classnames';
import {
  compose,
  withHandlers,
  withPropsOnChange,
  defaultProps,
} from 'recompose';

import styles from './styles.css';

export interface IButtonProps {
  title?: string;
  children?: string;
  type?: 'primary' | 'secondary' | 'warning' | 'pure' | 'dark';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  noHover?: boolean;
  tooltip?: string;
  tooltipPosition?: 'left' | 'right';
  tooltipStyle?: React.CSSProperties;
  onClick?: () => void;
  badge?: string;
  fullWidth?: boolean;
}

export const Button = compose<IButtonProps, any>(
  defaultProps({
    type: 'primary',
    size: 'medium',
    isLoading: false,
  }),
  withHandlers({
    onClick:
      ({ isLoading, disabled, onClick }) =>
      (e) => {
        if (disabled || isLoading || !onClick) return;
        e.preventDefault();
        return onClick(e);
      },
  })
)(
  ({
    title,
    children,
    onClick,
    type,
    size,
    disabled,
    isLoading,
    noHover,
    className,
    tooltip,
    tooltipPosition = 'left',
    tooltipStyle,
    badge,
    fullWidth,
    ...rest
  }: IButtonProps) => (
    <button
      disabled={disabled}
      onClick={onClick}
      {...rest}
      className={cx(
        styles.root,
        styles[`type-${type}`],
        styles[`size-${size}`],
        disabled && styles.disabled,
        isLoading && styles.loading,
        noHover && styles.noHover,
        fullWidth && styles.fullWidth,
        className
      )}
    >
      {title || children}
      {!!badge && <div className={styles.badge}>{badge}</div>}
      {tooltip && (
        <div
          className={cx(
            styles.tooltip,
            tooltipPosition === 'right' && styles.tooltipRight
          )}
          style={tooltipStyle || {}}
        >
          {tooltip}
        </div>
      )}
    </button>
  )
);

export default Button;
